import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const BIDDING_NOTICE_CORE_FIELDS = gql`
  fragment BiddingNoticeCoreFields on BiddingNotice {
    id
    message
    hiddenAt
  }
`;

export const BIDDING_NOTICE_FIELDS = gql`
  ${BIDDING_NOTICE_CORE_FIELDS}
  fragment BiddingNoticeFields on BiddingNotice {
    ...BiddingNoticeCoreFields
  }
`;

export const BIDDING_NOTICES = gql`
  ${BIDDING_NOTICE_FIELDS}
  query BiddingNotices {
    biddingNotices {
      ...BiddingNoticeFields
    }
  }
`;

const BIDDING_NOTICE_ARGUMENTS = `
  $message: String!
`;

const BIDDING_NOTICE_VARIABLES = `
  message: $message
`;

export const CREATE_BIDDING_NOTICE = gql`
  ${BIDDING_NOTICE_CORE_FIELDS}
  mutation CreateBiddingNotice (
    ${BIDDING_NOTICE_ARGUMENTS}
  ) {
    createBiddingNotice (
      ${BIDDING_NOTICE_VARIABLES}
    ) {
      biddingNotice {
        ...BiddingNoticeCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const HIDE_BIDDING_NOTICE = gql`
  ${BIDDING_NOTICE_CORE_FIELDS}
  mutation HideBiddingNotice ($id: ID!) {
    hideBiddingNotice (id: $id) {
      biddingNotice {
        ...BiddingNoticeCoreFields
      }
      ${ERRORS}
    }
  }
`;
